import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
// material-ui
import withStyles from "@material-ui/styles/withStyles";
// custom
import AssessmentsList from "components/AssessmentsList";
// reactor
import Page from "components/Page";
// constants
import { ASSESSMENT } from "constants/routes";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class WrapperAssessmentPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    assessments: PropTypes.array,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedAssessment: undefined,
      formAssessmentOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { assessments, history } = this.props;

    switch (index) {
      case 0:
        return (
          <AssessmentsList
            assessments={assessments}
            onSelect={(selectedAssessment) =>
              history.push(`${ASSESSMENT}?id=${selectedAssessment.id}`)
            }
          />
        );
      default:
    }

    return [];
  }

  render() {
    const { classes, history, loading } = this.props;

    const { index } = this.state;

    return (
      <Page
        helmet="Assessments"
        loading={loading}
        loadingMessage={"Fetching all Licenses"}
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({
                index: v,
              });
              history.push(`?index=${v}`);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="All"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperAssessmentPage);
